/*global themeVars */

const instanceVars = themeVars;
const { ajaxUrl } = instanceVars


/**
 * Function to handle a click event on a specific button, and send a POST request to track the button click.
 *
 * This function will find the primary custom button on the page and attach a click event listener to it.
 * When the button is clicked, a POST request will be sent to the specified ajax URL.
 * The request includes the necessary action to track the button click.
 */
export const abSmartlyButtonClick = () => {

	const buttons = document.querySelectorAll( 'a.try-for-free , .wp-block-button.try-for-free > .wp-block-button__link' );

	/**
	 * Retrieves the value of a cookie by name from the document's cookies.
	 *
	 * @param {string} cookieName - The name of the cookie to retrieve.
	 * @return {string|null} The value of the specified cookie, or null if the cookie is not found.
	 */
	function getCookie ( cookieName ){

		// Match the cookie name followed by anything except a semicolon
		const match = document.cookie.match( `(^|;)\\s*${cookieName}\\s*=\\s*([^;]*)` );
		return match ? decodeURIComponent( match[ 2 ] ) : null;

	}

	/**
	 * Appends a parameter to the current URL
	 * @param {HTMLAnchorElement} urlSource - The element with href.
	 * @param {string} paramName - The name of the parameter
	 * @param {string} paramValue - The value of the parameter
	 * @return {string} - The new URL with the parameter added
	 */
	function appendParameterToUrl ( urlSource, paramName, paramValue ){

		// Get the current URL
		const url = new URL( urlSource.href );

		// Set the parameter (will update if it already exists)
		url.searchParams.set( paramName, paramValue );

		// Return the new URL as a string
		return url.toString();

	}


	if ( buttons ) {

		buttons.forEach( button => {

			button.addEventListener( 'click', ( event ) => {

				const url = new URL( window.location.href );
				let absUniqueId = getCookie( 'abs_unique_id' );
				const absUrlParam = url.searchParams.get( 'abs' );

				if ( !absUniqueId && absUrlParam ) {

					absUniqueId = absUrlParam;

				}

				if ( absUniqueId ) {

					event.preventDefault();
					window.location.href = appendParameterToUrl( button, 'partner_user_id', absUniqueId );

				}
				fetch( ajaxUrl, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded',
					},
					body: new URLSearchParams( {
						action: 'track_button_click',
						userAgent: navigator.userAgent,
						browserLanguage: navigator.language,
						buttonId: button.id,
						nonce: instanceVars.security,
						userUniqueId: absUniqueId
					} ),
				} )
					.then( response => response.json() )

			} );

		} );

	}

}







